import React from "react";
import "../styles/Footer.css";
import {
  FaWhatsapp,
  FaInstagram,
  FaFacebookF,
  FaEnvelope,
} from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/team">Our Team</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/ServiceList">Services</Link>
            </li>
            <li>
              <a href="/contactForm">Contact</a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>
            📞 <a href="tel:+27832248608">+27 83 224 8608</a>
          </p>
          <p>
            📧{" "}
            <a href="mailto:globaltongue.official@gmail.com">
              globaltongue.official@gmail.com
            </a>
          </p>
        </div>

        {/* Social Media */}
        <div className="footer-section">
          <h4>Connect With Us</h4>
          <div className="social-icons">
            <a
              href="https://wa.me/27795795525"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://instagram.com/globaltongue"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://facebook.com/globaltongue"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com/globaltongue"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <span className="social-label">X</span>
            </a>
            <a href="mailto:globaltongue.official@gmail.com">
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Global Tongue. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
